import React from 'react';
import Icon from "./Icon";
import PropTypes from "prop-types";

const GridViewIcon = (props) => {
    const getClassName = () => {
        const btnTypeClass = props?.selected ? 'button--outline' : 'button--secondary' ;
        let className = `${(props.className || '')} button button--icon ${btnTypeClass}`;

        if(props.selected) {
            className += ' selected';
        }

        return className;
    }
    return (
        <button 
            className={getClassName()} 
            onClick={props.onClick}
            aria-selected={props.selected}
        >
            <span className="sr-only">Display Events in a Grid Layout</span>
            <Icon
                icon='icon-grid_view'
            />
        </button>
    );
}

GridViewIcon.propTypes = {
    selected: PropTypes.bool,
    onClick: PropTypes.func,
}

GridViewIcon.defaultProps = {
    selected: false,
    onClick: () => {}
}

export default GridViewIcon;
